module.exports = __webpack_public_path__ + "static/media/21ECLAC17.55d14276.jpg";